import { Directive, TemplateRef, input } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtHeader]',
})
export class PaginationTableColumnHeaderDirective {
	readonly cellClass = input<string>();
	readonly description = input<string>();

	constructor(public template: TemplateRef<any>) {}
}
